export default {
  companyFeedMetadata: {
    lastAnswer: 'Последний ответ',
    sent: 'Отправлено',
    question: 'Вопрос',
    loadMore: 'Загрузить ещё',
    showMore: 'Показать ещё',
    all: 'Все',
    statisticInterval: 'Данные за последние 60 дней',
    nothingFound: 'За выбранный период ничего не найдено. Попробуйте изменить период',
    successMessages: {
      noMore: 'Получены все ответы за данный период времени',
    },
    errorMessages: {
      load: 'Не удалось загрузить ленту',
    },
  },
};
